var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingsLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.029,
    height: 22.527,
    viewBox: "0 0 24.029 22.527",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "sliders-solid",
    d: "M0,34.773a1.5,1.5,0,0,1,1.5-1.5H4.067a3.752,3.752,0,0,1,3.442-2.253,3.793,3.793,0,0,1,3.44,2.253H22.527a1.5,1.5,0,0,1,0,3H10.949a3.793,3.793,0,0,1-3.44,2.253,3.752,3.752,0,0,1-3.442-2.253H1.5a1.5,1.5,0,0,1-1.5-1.5Zm9.011,0a1.5,1.5,0,1,0-1.5,1.5A1.5,1.5,0,0,0,9.011,34.773ZM16.52,23.509a3.793,3.793,0,0,1,3.44,2.253h2.567a1.5,1.5,0,0,1,0,3H19.96a3.793,3.793,0,0,1-3.44,2.253,3.747,3.747,0,0,1-3.44-2.253H1.5a1.5,1.5,0,0,1,0-3H13.08A3.747,3.747,0,0,1,16.52,23.509Zm1.5,3.755a1.5,1.5,0,1,0-1.5,1.5A1.5,1.5,0,0,0,18.022,27.264Zm4.505-9.011a1.5,1.5,0,0,1,0,3H12.451a3.793,3.793,0,0,1-3.44,2.253,3.747,3.747,0,0,1-3.44-2.253H1.5a1.5,1.5,0,0,1,0-3H5.571A3.751,3.751,0,0,1,9.011,16a3.8,3.8,0,0,1,3.44,2.253Zm-15.018,1.5a1.5,1.5,0,1,0,1.5-1.5A1.5,1.5,0,0,0,7.509,19.755Z",
    transform: "translate(0 -16)",
    fill: "#23b574"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsLogo);
export default __webpack_public_path__ + "static/media/settings-logo.50617ca9cc7429fd023721ae9c03b57b.svg";
export { ForwardRef as ReactComponent };